var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.92,
    height: 31.799,
    viewBox: "0 0 31.92 31.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M-437.71,227.68c-3.791-.494-13.693-10.427-14.108-14.156.528-.144,1.073-.322,1.632-.438a1.608,1.608,0,0,0,1.466-1.671,64.7,64.7,0,0,0-.971-6.843c-.085-.432-.963-.982-1.5-1a5.816,5.816,0,0,0-5.791,3.969,10.224,10.224,0,0,0-.111,6.474c2.089,7.392,6.957,12.6,13.3,16.561a16.243,16.243,0,0,0,9.8,2.758A6.311,6.311,0,0,0-427.7,227.8a1.951,1.951,0,0,0-1.523-2.547,33.5,33.5,0,0,0-4.358-.761c-2.6-.283-3.155.129-3.933,2.626C-437.566,227.28-437.628,227.442-437.71,227.68Z",
    transform: "translate(458.558 -202.562)",
    fill: "none",
    stroke: "#fcac00",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.2f41ee278c40412a9ac48894cbda0ec1.svg";
export { ForwardRef as ReactComponent };